import React, { useState } from "react";
import Layout from "./Layout/Layout";
import { BookOpen, Download } from "lucide-react";
import Atmsat from "../assets/आत्म साक्षात्कार का विज्ञान.pdf";
import KRISHNA from "../assets/कृष्ण की ओर On the way to Krishna.pdf";
import KRISHNAKADAM from "../assets/कृष्ण भवना मृत में पहला कदम.pdf";
import PUNARJANAM from "../assets/पुनरागमन.pdf";

const Ebooks = () => {
  const [pdfList] = useState([
    {
      name: "आत्म साक्षात्कार का विज्ञान",
      englishTitle: "The Science of Self-Realization",
      url: Atmsat,
      description: "Discover the scientific basis of yoga, karma, reincarnation, and spiritual enlightenment. A guide to finding inner peace and your true identity.",
      coverColor: "from-amber-700 to-amber-900 border-amber-950",
    },
    {
      name: "कृष्ण की ओर On the way to Krishna",
      englishTitle: "On the Way to Krishna",
      url: KRISHNA,
      description: "An introductory study on bhakti-yoga, showing how we can elevate our consciousness and return to our eternal spiritual home.",
      coverColor: "from-amber-600 to-amber-800 border-amber-900",
    },
    {
      name: "कृष्ण भवना मृत में पहला कदम",
      englishTitle: "First Step in Krishna Consciousness",
      url: KRISHNAKADAM,
      description: "A wonderful introductory treatise exploring the basic practices and elevated philosophy of pure devotional service.",
      coverColor: "from-yellow-700 to-amber-800 border-amber-950",
    },
    {
      name: "पुनरागमन",
      englishTitle: "Second Chance (Reincarnation)",
      url: PUNARJANAM,
      description: "An extraordinary journey through the laws of karma and past lives, outlining the science of the soul's transition after death.",
      coverColor: "from-amber-800 to-stone-900 border-stone-950",
    },
  ]);

  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (url) => {
    window.open(url, "_blank");
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#fffbf4] to-[#fff6e6] py-16 px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-800 font-semibold text-xs tracking-[0.25em] uppercase mb-3 block">
            Digital Library
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-amber-950 tracking-wider">
            Srila Prabhupada E-Books
          </h2>
          <div className="h-[2px] w-24 bg-amber-500 mx-auto mt-4"></div>
          <p className="text-stone-600 mt-4 max-w-xl mx-auto font-light text-sm md:text-base">
            Read online or download authentic translations and commentaries on ancient Vedic literature in Hindi.
          </p>
        </div>

        {/* Ebooks Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto mt-6">
          {pdfList.map((pdf, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-sm border border-amber-100 hover:shadow-xl hover:scale-[1.01] transition-all duration-300 p-6 flex flex-col sm:flex-row gap-6 items-stretch"
            >
              {/* CSS Book Cover Mockup */}
              <div className={`w-full sm:w-40 h-56 rounded-2xl bg-gradient-to-br ${pdf.coverColor} shadow-md flex flex-col justify-between p-4 border-l-[8px] text-white relative shrink-0 overflow-hidden`}>
                {/* Decorative border */}
                <div className="absolute inset-2 border border-white/10 rounded-lg pointer-events-none"></div>
                <div className="relative z-10">
                  <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-amber-200 block mb-2">
                    Veda Series
                  </span>
                  <p className="text-sm font-bold leading-snug line-clamp-3">
                    {pdf.name}
                  </p>
                </div>
                <div className="relative z-10 border-t border-white/20 pt-2">
                  <p className="text-[8px] uppercase tracking-[0.1em] font-bold text-amber-200">
                    A.C. Bhaktivedanta
                  </p>
                  <p className="text-[8px] uppercase tracking-[0.1em] text-white/80">
                    Swami Prabhupada
                  </p>
                </div>
              </div>

              {/* Book Details */}
              <div className="flex flex-col flex-1 py-1">
                <span className="text-amber-800 font-bold text-xs uppercase tracking-wider mb-1">
                  {pdf.englishTitle}
                </span>
                <h3 className="text-xl font-serif font-bold text-amber-950 mb-3 leading-snug">
                  {pdf.name}
                </h3>
                <p className="text-stone-500 font-light text-sm leading-relaxed mb-6">
                  {pdf.description}
                </p>

                {/* Actions */}
                <div className="flex flex-wrap gap-3 mt-auto">
                  <button
                    className="flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-white font-semibold text-xs py-3 px-5 rounded-xl transition-all duration-300 shadow-sm"
                    onClick={() => handleView(pdf.url)}
                  >
                    <BookOpen size={14} /> Read Online
                  </button>
                  <button
                    className="flex items-center gap-2 bg-amber-100 hover:bg-amber-200 text-amber-900 font-semibold text-xs py-3 px-5 rounded-xl transition-all duration-300 shadow-sm"
                    onClick={() => handleDownload(pdf.url, pdf.name)}
                  >
                    <Download size={14} /> Download PDF
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Ebooks;
